import { Time } from "./time";
import { Wallet } from "./interfaces/wallet";
import { TRADE_TYPE, TradeOfferModel } from "./trade-offer.model";

export interface ITaxSwapAPIModel {
	type: string;
	attributes: ITaxSwapAPIAttributesModel;
}

export interface ITaxSwapAPIAttributesModel {
	tax_amount_fiat: string;
	tax_amount_asset: string;
	is_tax_service_available: boolean;
	fiat_id: string;
	asset_id: string;
}

interface ISwapFeeAttributes {
	amount: string;
	source: string;
	target: string;
	fiat_id: string;
}

export interface ISwapFeeApiResponse {
	type: string;
	attributes: ISwapFeeAttributes;
}

export interface ISwapFee {
	feeAmount: string;
	netValue: string;
	swapAmount: string;
	sourceAmount: string;
	targetAmount: string;
	fiatId: string;
}

export class SwapOfferModel extends TradeOfferModel {
	public source_crypto_amount: string = "";
	public source_wallet_id: string = "";
	public target_crypto_amount: string = "";
	public target_wallet_id: string = "";
	public created_at: Time = new Time();
	private source_crypto_amount_bfc: string = "";
	private target_crypto_amount_bfc: string = "";
	protected type: TRADE_TYPE = TRADE_TYPE.SWAP;

	// Additional to the API model
	protected offer_validity: number = 30; // Seconds
	public source_wallet: Wallet;
	public target_wallet: Wallet;
	private requestedFor: string = "";
	private updateFinished: boolean = false;

	//additional for fee transparency
	private fee_percentage_sell = "";
	private fee_percentage_buy: "";
	public isFeeTransparent = false;
	public fee: Partial<ISwapFeeApiResponse>;

	public get sourceAmountBfc(): string {
		return this.source_crypto_amount_bfc;
	}

	public get targetAmountBfc(): string {
		return this.target_crypto_amount_bfc;
	}

	public setRequestedFor(s: string): void {
		this.requestedFor = s;
	}

	public getRequestedFor(): string {
		return this.requestedFor;
	}

	public getRequestedForSource(): boolean {
		return this.requestedFor === "source";
	}

	public getRequestedForTarget(): boolean {
		return this.requestedFor === "target";
	}

	public getUpdateFinished(): boolean {
		return this.updateFinished;
	}

	public setUpdateFinished(b: boolean): void {
		this.updateFinished = b;
	}

	public getIsFeeTransparent(): boolean {
		return this.isFeeTransparent;
	}

	public getSwapFee(): ISwapFee | null {
		if (!this.isFeeTransparent && !this.fee) {
			return null;
		}

		const { amount, fiat_id, source, target } = this.fee.attributes;

		return {
			feeAmount: amount,
			netValue: this.target_crypto_amount,
			swapAmount: source,
			fiatId: fiat_id,
			sourceAmount: source,
			targetAmount: target
		};
	}

	public hasData(): boolean {
		return (
			!!this.source_wallet_id &&
			!!this.target_wallet_id &&
			!!this.source_crypto_amount &&
			!!this.target_crypto_amount
		);
	}
}
